export const BillingType = {
  Recurring: "recurring",
  OneTime: "one_time",
};
